import React, { createContext, useContext, useState, ReactNode } from 'react';
import { AlertColor } from '@mui/material';

interface NotificationContextType {
  showNotification: (message: string, type: AlertColor) => void;
  hideNotification: () => void;
  notification: {
    message: string;
    type: AlertColor;
    open: boolean;
    key: number;
  };
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [notification, setNotification] = useState({
    message: '',
    type: 'success' as AlertColor,
    open: false,
    key: 0,
  });

  const showNotification = (message: string, type: AlertColor) => {
    setNotification(prev => {
      const next = { message, type, open: true, key: Date.now() };
      if (prev.open) {
        // Zuerst schließen, dann kurz danach neu öffnen, damit die Animation sichtbar ist
        setTimeout(() => setNotification(next), 150);
        return { ...prev, open: false };
      }
      return next;
    });
  };

  const hideNotification = () => {
    setNotification(prev => ({
      ...prev,
      open: false,
    }));
  };

  return (
    <NotificationContext.Provider value={{ showNotification, hideNotification, notification }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};